import showcase from '@app/lang/reverse/de/showcase';
import { COMMON_DE } from '@app/lang/reverse/de/common';
import { SEARCHING_DE } from '@app/lang/reverse/de/searching';
import { INTERVIEWING_DE } from '@app/lang/reverse/de/interviewing';
import { CLOSING_DE } from '@app/lang/reverse/de/closing';
import { SUCCESS_FEE_DE } from '@app/lang/reverse/de/success-fee';
import { HOMEPAGE_DE } from '@app/lang/reverse/de/homepage';
import { CANDIDATE_DETAILS_DE } from '@app/lang/reverse/de/candidate-details';
import { ERRORS_DE } from '@app/lang/reverse/de/errors';
import * as PROFILING_DE from '@app/lang/reverse/de/profiling.json';
import * as LOGIN_DE from '@app/lang/reverse/de/login.json';
import * as GLOBAL_COMPENSATION_DE from '@app/lang/reverse/de/global-compensation.json';

const DE = {
  translation: {
    header: {
      welcome: 'Willkommen',
      share: 'Teilen',
      hide_compensation: 'Präsentieren mit ausgeblendeter Vergütung',
      show_compensation: 'Vergütung anzeigen',
    },
    hero: {
      backToHomepage: 'Alle Ihre Services',
      backToHomepage_headHunter: 'Alle Services des Kunden',
      prospect: {
        title: 'Vorschau Success Berechnung',
      },
      steps: {
        profiling: {
          title: 'Profil',
          title_no_miro: 'Ansprechpartner',
          description: 'Start',
        },
        searching: {
          title: 'Suche',
          description: 'Tag 1-10',
        },
        showcase: {
          title: 'Showcase',
          description: 'Tag 11',
        },
        interviewing: {
          title: 'Gespräche',
          title_marketing: 'Talente',
          description: 'Tag 11-20',
        },
        closing: {
          title: 'Einstellung',
          description: 'Ende',
        },
      },
      helper: {
        profiling: {
          'to-do':
            'Hallo. Auf diesen Seiten können Sie jeden Schritt der Aktivitäten <strong>sehen</strong>, die wir für Sie durchführen, aktualisiert in Echtzeit.',
          'to-do_withName':
            'Hallo {{ name }}. Auf diesen Seiten können Sie jeden Schritt der Aktivitäten <strong>sehen</strong>, die wir für Sie durchführen, aktualisiert in Echtzeit.',
          doing: '$t(hero.helper.profiling.to-do)',
          doing_withName: '$t(hero.helper.profiling.to-do_withName)',
          done: '$t(hero.helper.profiling.to-do)',
          done_withName: '$t(hero.helper.profiling.to-do_withName)',
        },
        searching: {
          'to-do':
            'Bis die Daten verfügbar sein werden, <strong>sehen Sie die Aktivitäten, die ich für Sie durchführe</strong>',
          doing:
            'Bis die Daten verfügbar sein werden, <strong>sehen Sie die Aktivitäten, die ich für Sie durchführe</strong>',
          done: 'Wir haben den Kandidaten Ihr Unternehmen und die Position vorgestellt. Das ist es, <strong>was uns die Zahlen sagen</strong>.',
        },
        interviewing: {
          'to-do':
            'In dieser Phase zeigen wir Ihnen die Bewerber und werden zeitnahes Feedback einfordern',
          doing:
            'Wir sind mittendrin. Denken Sie daran, <strong>je schneller wir sind, desto größer ist die Chance</strong>, dass wir einstellen.',
          done: 'Wir sind mittendrin. Denken Sie daran, <strong>je schneller wir sind, desto größer ist die Chance</strong>, dass wir einstellen.',
        },
        closing: {
          'to-do':
            'Das ist die finale Phase: die empfindlichste von allen. <strong>Verhandlung, Kündigung des alten Jobs und onboarding</strong>.',
          doing:
            'Das ist die finale Phase: die empfindlichste von allen. <strong>Verhandlung, Kündigung des alten Jobs und onboarding</strong>.',
          done: 'Tolle Leistung! Hier finden Sie eine Zusammenfassung der Kosten und alle nötigen Unterlagen.',
        },
        marketing: {
          profiling: {
            'to-do':
              'Hallo. Auf diesen Seiten sehen Sie die <strong>Talente, die wir für Sie ausgewählt haben</strong>, und wenn Sie sich entscheiden, sie zu treffen, <strong>alles über ihren Status im Auswahlverfahren</strong>.',
            'to-do_withName':
              'Hallo {{ name }}. Auf diesen Seiten sehen Sie die <strong>Talente, die wir für Sie ausgewählt haben</strong>, und wenn Sie sich entscheiden, sie zu treffen, <strong>alles über ihren Status im Auswahlverfahren</strong>.',
            doing: '$t(hero.helper.marketing.profiling.to-do)',
            doing_withName:
              '$t(hero.helper.marketing.profiling.to-do_withName)',
            done: '$t(hero.helper.marketing.profiling.to-do)',
            done_withName: '$t(hero.helper.marketing.profiling.to-do_withName)',
          },
          interviewing: {
            'to-do':
              'Sobald Talente identifiziert werden, die <strong>für dich passen könnten</strong>, findest du sie hier.',
            doing:
              'Interessante Kandidaten bleiben nicht lange verfügbar. <strong>Verpass nicht die Gelegenheit, sie kennenzulernen</strong>.',
            done: '$t(hero.helper.marketing.interviewing.doing)',
          },
        },
      },
    },
    profile: {
      contract: {
        title:
          'Hier finden Sie die Dienstleistunsvereinbarung für dieses Mandat',
        title_marketing:
          'Entdecken Sie Top-Talente,<br/>Zahlen Sie nur, wenn Sie einstellen.',
        download: 'Download the contract',
      },
      references: {
        title: 'Ihre Ansprechpartner',
        blank: {
          title: 'Zuweisen',
          subtitle: 'Head Hunter',
          text: 'Je nach Mandat auswählen',
        },
      },
      mirror: {
        body: '<strong>Eine neue Art des Recruitings</strong><br><br>FLEXIBEL, DIGITAL UND SPEZIALISIERT.',
        link: 'Entdecken Sie das Collaborative Recruiting',
      },
    },
    general: {
      error: {
        title: 'Ein Fehler ist aufgetreten',
        subtitle:
          'Seite neu laden. Wenn der Fehler weiterhin besteht, versuchen Sie es später nochmal.',
        button: 'Go back to home',
        hash: {
          title: 'Der Link ist nicht mehr gültig.',
          subtitle:
            'Sie sollten den <strong>korrekten Link</strong> in einer <strong>unserer Emails</strong> erhalten haben.',
          disclaimer:
            'Kannst du es nicht finden? <strong>Kontaktiere deinen Ansprechpartner</strong>',
        },
        unauthorized: {
          title: 'Der Link ist falsch.',
          subtitle:
            'Sie sollten den <strong>korrekten Link</strong>, kurz nach Vertragsunterzeichnung, in einer <strong>unserer Emails</strong> erhalten haben.',
          disclaimer:
            'Kannst du es nicht finden? <strong>Kontaktiere deinen Ansprechpartner</strong>',
        },
        unauthorizedHomepage: {
          title: 'Sie sind nicht berechtigt, diese Seite anzuzeigen.',
          subtitle: '',
          disclaimer: '',
        },
      },
      document_title: {
        profiling: 'Profil',
        searching: 'Suche',
        interviewing: 'Gespräche',
        closing: 'Closing',
        showcase: 'Showcase',
      },
      document_title_reverse_marketing: {
        profiling: '$t(hero.steps.profiling.title_no_miro)',
        searching: '$t(hero.steps.searching.title)',
        interviewing: '$t(hero.steps.interviewing.title_marketing)',
        closing: '$t(hero.steps.closing.title)',
        showcase: '$t(hero.steps.showcase.title)',
      },
      date_on: 'am',
      date_hour: 'um',
    },
    candidate: {
      hero: {
        title: 'Sie suchen:',
        back_label: 'Zurück',
      },
      infos: {
        age: 'Jahre',
        benefits: 'Aktuelle Benefits',
        bonuses: 'Aktuelle Boni',
      },
      sections: {
        horse: {
          title: 'Aktueller Status',
        },
        bet: {
          open_chat: 'Mit <strong>{{ name }}</strong> chatten',
        },
        curriculum: {
          title: 'Lebenslauf',
          screening: 'Screening ranking',
          button: 'Lebenslauf runterladen',
        },
        summary: {
          otherSelectionsTitle: 'Andere Auswahlverfahren',
        },
        concerns: {
          intro:
            '{{ name }} ist ein sehr interessantes Profil, das aber nicht ganz den Anforderungen entspricht.',
        },
      },
    },
    footer: {
      company: 'Reverse Deutschland GmbH',
      headquarter: 'Firmensitz: Unter den Linden 26‑30, Berlin',
      informations: [
        'MwSt Nr: DE328318880',
        'info.de@reverse.hr',
        'Handelsregister: Amtsgericht Berlin-Charlottenburg, HRB 213573',
        'Grundkapital: 50.000€',
      ],
      menu: {
        contact: {
          label: 'Kontaktieren Sie uns',
          slug: 'kontaktieren-sie-uns',
        },
        legal: {
          label: 'Legal',
          slug: 'legal',
        },
        cookies: {
          label: 'Cookies',
          url: 'https://www.iubenda.com/privacy-policy/28745003/cookie-policy',
        },
        impressum: {
          label: 'Impressum',
          slug: 'impressum',
        },
      },
    },
    modal: {
      share: {
        title: 'Den Auswahlfortschritt mit anderen teilen',
        inputs: {
          first_name: {
            label: 'Name',
            placeholder: 'Name',
          },
          last_name: {
            label: 'Nachname',
            placeholder: 'Nachname',
          },
          email: {
            label: 'E-Mail',
            placeholder: 'E-Mail',
            hint: 'Diese E-Mail Adresse entspricht nicht der Domani mit der Sie sich angemeldet haben. Sind SIe sicher, fortfahren zu wollen?',
          },
          lang: {
            label: 'Sprache',
            placeholder: 'Sprache auswählen',
          },
        },
        isCompensationPackageVisible: {
          label:
            'Der eingeladenen Person erlauben, <strong>die Vergütungspakete der Kandidaten einzusehen</strong>.',
        },
        lang_options: {
          it: 'Italienish',
          en: 'Englisch',
          de: 'Deutsch',
          fr: 'Französisch',
          es: 'Spanisch',
        },
        button: 'Einladung senden',
        shared_with: 'Geteilt mit',
        alert: {
          positive: 'Die E-Mail-Einladung wurde gesende',
          negative:
            'Irgendwashat nicht geklappt. Bitte versuchen Sie es erneut, oder kontaktieren Sie Ihre Ansprechpartner',
          guest_info:
            'Die eingeladene Person kann die Vergütungspakete der Kandidaten nicht sehen. Wenn sie Zugriff auf diese Informationen benötigt, wenden Sie sich an {{ mainClient }} oder den Headhunter, um die Berechtigungen zu aktivieren.',
        },
        table: {
          header: {
            name: 'Vorname',
            email: 'E-Mail',
            compensationVisibility: 'Vergütungssichtbarkeit',
          },
          guest: '(Gast)',
          mainClient: '(Hauptkunde)',
        },
      },
    },
    validation: {
      scout_approved: 'von Scout überprüft',
      scout_required: 'muss von Scout überprüft werden',
      required: 'This field is required',
      email: 'This email address is not valid',
    },
    language_switcher: {
      it: 'IT',
      en: 'EN',
      de: 'DE',
      fr: 'FR',
      es: 'ES',
    },
    showcase,
    candidateDetails: CANDIDATE_DETAILS_DE,
    common: COMMON_DE,
    searching: SEARCHING_DE,
    interviewing: INTERVIEWING_DE,
    closing: CLOSING_DE,
    successFee: SUCCESS_FEE_DE,
    globalCompensation: GLOBAL_COMPENSATION_DE,
    homepage: HOMEPAGE_DE,
    login: LOGIN_DE,
    profiling: PROFILING_DE,
    errors: ERRORS_DE,
  },
};

export default DE;
